// collection-page.js
(function () {
  // -------------------------
  // Quick price ranges config
  // -------------------------
  var __priceQuickCache = new Map();      // cacheKey -> buckets
  var __priceQuickInflight = new Map();   // cacheKey -> Promise<buckets>

  var PRICE_QUICK_CACHE_VERSION = "v2";     // bump if you change logic
  var PRICE_QUICK_CACHE_TTL_MS = 10 * 60 * 1000; // 10 minutes

  function storageKey(k) {
    return "priceQuick:" + PRICE_QUICK_CACHE_VERSION + ":" + k;
  }

  function storageGet(k) {
    try {
      var raw = sessionStorage.getItem(storageKey(k));
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !obj.ts || !obj.data) return null;
      if ((Date.now() - obj.ts) > PRICE_QUICK_CACHE_TTL_MS) {
        sessionStorage.removeItem(storageKey(k));
        return null;
      }
      return obj.data; // buckets array
    } catch (e) {
      return null;
    }
  }

  function storageSet(k, data) {
    try {
      sessionStorage.setItem(storageKey(k), JSON.stringify({
        ts: Date.now(),
        data: data
      }));
    } catch (e) {
      // storage might be full or blocked; ignore
    }
  }

  function autoSelectInStockOnFirstLoad() {
    var form = document.getElementById("CollectionFiltersForm");
    if (!form) return;

    var url = new URL(window.location.href);

    // Do nothing if any filter is already active
    var hasFilterParams = false;
    url.searchParams.forEach(function (_, key) {
      if (key.indexOf("filter.") === 0) hasFilterParams = true;
    });
    if (hasFilterParams) return;

    // Only auto-apply once per collection path in this browser session
    var storageKey = "autoInStockApplied:" + url.pathname;
    try {
      if (sessionStorage.getItem(storageKey) === "true") return;
    } catch (e) {}

    // Find the "In stock" checkbox by label text
    var labels = form.querySelectorAll(".facet__value label");
    var targetInput = null;

    labels.forEach(function (label) {
      var text = (label.textContent || "").trim().toLowerCase();
      var input = label.querySelector('input[type="checkbox"]');

      if (!input) return;

      // Match common Shopify stock filter labels
      if (
        text.indexOf("in stock") !== -1 ||
        text.indexOf("availability") !== -1 && text.indexOf("in stock") !== -1
      ) {
        targetInput = input;
      }
    });

    if (!targetInput || targetInput.checked || targetInput.disabled) return;

    targetInput.checked = true;

    try {
      sessionStorage.setItem(storageKey, "true");
    } catch (e) {}

    if (form.requestSubmit) form.requestSubmit();
    else form.submit();
  }

  function parseLocaleNumber(val) {
    if (val == null) return 0;
    var s = String(val).trim().replace(/\s/g, "");
    var hasComma = s.indexOf(",") !== -1;
    var hasDot = s.indexOf(".") !== -1;

    if (hasComma && hasDot) return parseFloat(s.replace(/,/g, "")); // 1,234.56
    if (hasComma && !hasDot) return parseFloat(s.replace(/,/g, ".")); // 1234,56
    return parseFloat(s);
  }

  function toInt(n) {
    var x = Math.round(parseLocaleNumber(n));
    return Number.isFinite(x) ? x : 0;
  }

  function getNiceStep(rangeMax) {
    if (rangeMax >= 10000) return 1000;
    if (rangeMax >= 5000) return 500;
    if (rangeMax >= 1000) return 100;
    if (rangeMax >= 100) return 10;
    return 1;
  }

  function roundUp(n, step) {
    return Math.ceil(n / step) * step;
  }

  function sanitizeCollectionUrl({ replaceHistory }) {
    try {
      var url = new URL(window.location.href);

      // Remove Shopify search / tracking noise
      ["_pos", "_psq", "_ss", "_v"].forEach(function (k) {
        url.searchParams.delete(k);
      });

      // Remove common non-SEO + state params
      ["section_id"].forEach(function (k) {
        url.searchParams.delete(k);
      });

      // Remove empty params (including empty filter values)
      // Note: URLSearchParams iterates live; copy keys first.
      var keys = [];
      url.searchParams.forEach(function (_, k) { keys.push(k); });
      keys.forEach(function (k) {
        var vals = url.searchParams.getAll(k);
        // remove empties, then re-add non-empty (keeps multi-values)
        url.searchParams.delete(k);
        vals.forEach(function (v) {
          if (String(v).trim() !== "") url.searchParams.append(k, v);
        });
      });

      // If price filters exist but are empty, they’re already removed above.
      // If you also want to remove price params when both missing, nothing else needed.

      // Stable sort params (prevents multiple URLs for same filters)
      var entries = [];
      url.searchParams.forEach(function (v, k) { entries.push([k, v]); });
      entries.sort(function (a, b) {
        if (a[0] === b[0]) return a[1] < b[1] ? -1 : a[1] > b[1] ? 1 : 0;
        return a[0] < b[0] ? -1 : 1;
      });

      var clean = new URL(url.origin + url.pathname);
      entries.forEach(function (pair) { clean.searchParams.append(pair[0], pair[1]); });

      // Only update if changed
      if (clean.toString() !== window.location.href) {
        if (replaceHistory) window.history.replaceState({}, "", clean.toString());
        else window.history.pushState({}, "", clean.toString());
      }
    } catch (e) {
      // ignore
    }
  }

  function buildQuarterBuckets(rangeMax) {
    rangeMax = toInt(rangeMax);
    if (rangeMax <= 0) return [];

    var step = getNiceStep(rangeMax);

    // Raise max to a clean rounded number
    var cleanMax = roundUp(rangeMax, step);

    // Build rounded edges (shared boundaries)
    var edges = [
      0,
      roundUp(cleanMax * 0.25, step),
      roundUp(cleanMax * 0.50, step),
      roundUp(cleanMax * 0.75, step),
      cleanMax
    ];

    // Ensure edges are strictly non-decreasing
    for (var i = 1; i < edges.length; i++) {
      if (edges[i] < edges[i - 1]) edges[i] = edges[i - 1];
    }

    var buckets = [];
    for (var b = 0; b < 4; b++) {
      var min = (b === 0) ? edges[b] : (edges[b] + 1); // +1 avoids overlap
      var max = edges[b + 1];;

      // If rounding collapsed the bucket, clamp it to a valid single-point range
      if (min > max) min = max;

      buckets.push({ min: min, max: max, count: 0 });
    }

    return buckets;
  }

  // Merge any bucket with 0 count into the next bucket on the right
  function mergeZeroBucketsRight(buckets) {
    var out = [];
    for (var i = 0; i < buckets.length; i++) {
      var b = buckets[i];

      if (b.count === 0 && i < buckets.length - 1) {
        var next = buckets[i + 1];
        next.min = b.min;
        continue;
      }
      out.push(b);
    }

    if (out.length && out[out.length - 1].count === 0 && out.length > 1) {
      var last = out.pop();
      var prev = out[out.length - 1];
      prev.max = last.max;
    }

    return out.filter(function (b) { return b.count > 0; });
  }

  function formatCurrency(n) {
    return "$" + n.toLocaleString();
  }

  function formatRangeLabel(min, max) {
    return formatCurrency(min) + " – " + formatCurrency(max);
  }

  function findPriceInputs(form) {
    // Your markup uses PriceMin / PriceMax
    var min = form.querySelector("#PriceMin");
    var max = form.querySelector("#PriceMax");

    // Fallbacks if IDs ever change
    if (!min || !max) {
      var priceBlock = form.querySelector(".facet__price-inputs");
      if (priceBlock) {
        var nums = priceBlock.querySelectorAll('input[type="number"]');
        if (nums.length >= 2) {
          min = nums[0];
          max = nums[1];
        }
      }
    }

    return { min: min, max: max };
  }

  function renderSkeleton(mount, buckets) {
    mount.innerHTML =
      '<div class="price-quick__grid" data-grid></div>';

    var grid = mount.querySelector("[data-grid]");
    buckets.forEach(function (b) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "price-quick__btn is-loading";
      btn.disabled = true;
      btn.innerHTML =
        '<span class="facet__value-label">' + formatRangeLabel(b.min, b.max) + '</span>' +
        '<span class="facet__value-count">(…)</span>';
      grid.appendChild(btn);
    });
  }

  function renderBuckets(mount, form, buckets) {
    mount.innerHTML =
      '<div class="price-quick__grid" data-grid></div>';

    var grid = mount.querySelector("[data-grid]");

    buckets.forEach(function (b) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "price-quick__btn";
      btn.innerHTML =
        '<span class="facet__value-label">' + formatRangeLabel(b.min, b.max) + '</span>' +
        '<span class="facet__value-count">(' + b.count + ')</span>';

      btn.addEventListener("click", function () {
        var inputs = findPriceInputs(form);
        if (!inputs.min || !inputs.max) return;

        inputs.min.value = String(b.min);
        inputs.max.value = String(b.max);

        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });

      grid.appendChild(btn);
    });
  }

  async function fetchHTML(url) {
    var res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) return null;
    return await res.text();
  }

  function parsePricesFromDoc(doc) {
    // Your cards: .product-card__price (best). Keep fallbacks.
    var nodes = doc.querySelectorAll(
      ".product-card__price, .price, .price-item, [data-product-price]"
    );

    var prices = [];
    nodes.forEach(function (el) {
      var text = (el.textContent || "").trim();

      // Grab first numeric chunk
      var match = text.match(/(\d[\d.,\s]*)/);
      if (!match) return;

      // AU thousands separator handling
      var raw = match[1].replace(/\s/g, "").replace(/,/g, "");
      var n = parseFloat(raw);
      if (!Number.isFinite(n)) return;

      prices.push(Math.round(n));
    });

    return prices;
  }

  function parseTotalPages(doc) {
    var pageLinks = doc.querySelectorAll(
      ".pagination a[href*='page='], nav.pagination a[href*='page=']"
    );

    var max = 1;
    pageLinks.forEach(function (a) {
      try {
        var u = new URL(a.getAttribute("href"), window.location.origin);
        var p = parseInt(u.searchParams.get("page") || "1", 10);
        if (p > max) max = p;
      } catch (e) {}
    });

    return max;
  }

  async function fetchAllFilteredPrices(currentUrl, maxPagesCap) {
    var base = new URL(currentUrl);
    base.searchParams.delete("page");

    var html1 = await fetchHTML(base.toString());
    if (!html1) return [];

    var doc1 = new DOMParser().parseFromString(html1, "text/html");
    var prices = parsePricesFromDoc(doc1);

    var totalPages = parseTotalPages(doc1);
    var cap = maxPagesCap || 30;
    totalPages = Math.min(totalPages, cap);

    for (var page = 2; page <= totalPages; page++) {
      var u = new URL(base.toString());
      u.searchParams.set("page", String(page));

      var html = await fetchHTML(u.toString());
      if (!html) break;

      var doc = new DOMParser().parseFromString(html, "text/html");
      var more = parsePricesFromDoc(doc);

      if (!more.length) break;
      prices = prices.concat(more);
    }

    return prices;
  }

  function countPricesIntoBuckets(prices, buckets) {
    buckets.forEach(function (b) { b.count = 0; });

    prices.forEach(function (dollars) {
      for (var i = 0; i < buckets.length; i++) {
        var b = buckets[i];
        if (dollars >= b.min && dollars <= b.max) {
          b.count += 1;
          break;
        }
      }
    });

    return buckets;
  }

  function getCacheKeyWithoutPrice() {
    var url = new URL(window.location.href);

    // Remove price params so quick-counts aren’t affected by price selection
    [
      "filter.v.price.gte",
      "filter.v.price.lte",
      "filter.p.price.gte",
      "filter.p.price.lte",
      "page",
      "section_id",
      "sort_by"
    ].forEach(function (k) {
      url.searchParams.delete(k);
    });

    // Build a stable, sorted query string
    var entries = [];
    url.searchParams.forEach(function (v, k) {
      entries.push([k, v]);
    });
    entries.sort(function (a, b) {
      if (a[0] === b[0]) return a[1] < b[1] ? -1 : a[1] > b[1] ? 1 : 0;
      return a[0] < b[0] ? -1 : 1;
    });

    var stable = new URL(url.origin + url.pathname);
    entries.forEach(function (pair) {
      stable.searchParams.append(pair[0], pair[1]);
    });

    return stable.toString();
  }

  async function computeBucketsForCurrentFilters(rangeMax) {
    var cacheKey = getCacheKeyWithoutPrice();

    // 0) Persistent cache (survives page reload)
    var stored = storageGet(cacheKey);
    if (stored && stored.length) {
      // also hydrate in-memory cache
      __priceQuickCache.set(cacheKey, stored);
      return stored;
    }

    // 1) In-memory cache (same page session)
    var cached = __priceQuickCache.get(cacheKey);
    if (cached) return cached;

    // 2) In-flight de-dupe
    var inflight = __priceQuickInflight.get(cacheKey);
    if (inflight) return await inflight;

    var p = (async function () {
      try {
        var buckets = buildQuarterBuckets(rangeMax);
        if (!buckets.length) return [];

        var prices = await fetchAllFilteredPrices(cacheKey, 30);
        buckets = countPricesIntoBuckets(prices, buckets);
        buckets = mergeZeroBucketsRight(buckets);

        __priceQuickCache.set(cacheKey, buckets);
        storageSet(cacheKey, buckets);

        return buckets;
      } finally {
        __priceQuickInflight.delete(cacheKey);
      }
    })();

    __priceQuickInflight.set(cacheKey, p);
    return await p;
  }

  async function initPriceQuickButtons() {
    var form = document.getElementById("CollectionFiltersForm");
    if (!form) return;

    var mounts = form.querySelectorAll("[data-price-quick]");
    if (!mounts.length) return;

    for (var i = 0; i < mounts.length; i++) {
      var mount = mounts[i];

      var productsCount = toInt(mount.getAttribute("data-products-count") || "0");
      if (productsCount < 1) {
        mount.innerHTML = "";
        continue;
      }

      var rangeMax = mount.getAttribute("data-range-max");
      var skeletonBuckets = buildQuarterBuckets(rangeMax);
      if (!skeletonBuckets.length) {
        mount.innerHTML = "";
        continue;
      }

      // 1) If cached, render instantly (no skeleton flash)
      var cacheKey = getCacheKeyWithoutPrice();
      var cached = __priceQuickCache.get(cacheKey) || storageGet(cacheKey);
      if (cached) {
        __priceQuickCache.set(cacheKey, cached); // hydrate memory
        renderBuckets(mount, form, cached);
        continue;
      }

      // 2) Show skeleton only if not cached
      renderSkeleton(mount, skeletonBuckets);

      // 3) Compute (deduped + cached), then render
      try {
        var buckets = await computeBucketsForCurrentFilters(rangeMax);
        if (!buckets.length) {
          mount.innerHTML = "";
          continue;
        }
        renderBuckets(mount, form, buckets);
      } catch (e) {
        // Fail gracefully (keep skeleton, or clear)
        // mount.innerHTML = "";
      }
    }
  }

  // -------------------------
  // Refresh triggers (faster UX)
  // -------------------------
  var __quickTimer;
  function scheduleQuickRefresh() {
    window.clearTimeout(__quickTimer);
    __quickTimer = window.setTimeout(function () {
      initPriceQuickButtons();
    }, 150);
  }

  function watchRerenders() {
    var __lastQuickKey = getCacheKeyWithoutPrice();
    // Only watch the area Dawn replaces (product grid)
    var targets = [
      document.querySelector(".collection-main")
    ].filter(Boolean);

    if (!targets.length) return;

    var t;
    function debounced() {
      window.clearTimeout(t);
      t = window.setTimeout(function () {
        // Only refresh quick-price buckets if filters (not sort/pagination) changed
        var k = getCacheKeyWithoutPrice();
        if (k !== __lastQuickKey) {
          __lastQuickKey = k;
          initPriceQuickButtons();
        }

        // Still recompute card media height if you’re using that feature
        if (typeof scheduleUniformMediaHeight === "function") {
          scheduleUniformMediaHeight();
        }
      }, 80);
    }

    var obs = new MutationObserver(function (mutations) {
      // Ignore mutations coming from our own quick-price rendering
      // (anything inside the quick-price mount)
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.target && m.target.closest && m.target.closest("[data-price-quick]")) {
          return; // ignore
        }
      }
      debounced();
    });

    targets.forEach(function (el) {
      obs.observe(el, { childList: true, subtree: true });
    });

    // Dawn section reloads
    document.addEventListener("shopify:section:load", debounced);

    // User changes filters -> refresh quick ranges
    var form = document.getElementById("CollectionFiltersForm");
    if (form) {
      form.addEventListener("change", function () {
        __lastQuickKey = getCacheKeyWithoutPrice();
        scheduleQuickRefresh();
        scheduleUniformMediaHeight();
      });
    }
  }

  // -------------------------
  // Uniform product card media height
  // -------------------------
  var __mediaTimer;

  function setUniformCardMediaHeight() {
    var medias = document.querySelectorAll(".product-card__media");
    var imgs = document.querySelectorAll(".product-card__image");
    if (!medias.length || !imgs.length) return;

    var mediaWidth = medias[0].getBoundingClientRect().width;
    if (!mediaWidth) return;

    var minNeeded = Infinity;

    imgs.forEach(function (img) {
      var nw = img.naturalWidth || 0;
      var nh = img.naturalHeight || 0;
      if (!nw || !nh) return;

      // Height needed at this width to show full image without cropping
      var needed = mediaWidth * (nh / nw);

      if (needed > 0 && needed < minNeeded) minNeeded = needed;
    });

    if (!Number.isFinite(minNeeded)) return;

    // Clamp so it doesn't get too short/tall
    var MIN = 180; // bump up if cards feel squashed
    var MAX = 360; // cap if needed
    var finalH = Math.max(MIN, Math.min(MAX, Math.round(minNeeded)));

    document.documentElement.style.setProperty("--card-media-height", finalH + "px");
  }

  function scheduleUniformMediaHeight() {
    window.clearTimeout(__mediaTimer);
    __mediaTimer = window.setTimeout(function () {
      setUniformCardMediaHeight();
    }, 80);
  }

  // Recompute after images load + on resize
  window.addEventListener("load", scheduleUniformMediaHeight);
  window.addEventListener("resize", function () {
    scheduleUniformMediaHeight();
  });

  // If some images load after initial render
  document.addEventListener(
    "load",
    function (e) {
      if (e.target && e.target.classList && e.target.classList.contains("product-card__image")) {
        scheduleUniformMediaHeight();
      }
    },
    true
  );

  // -------------------------
  // Buy it now (AJAX add -> checkout)
  // -------------------------
  document.addEventListener("click", async function (e) {
    var btn = e.target.closest("[data-buy-now]");
    if (!btn) return;

    var id = btn.getAttribute("data-variant-id");
    if (!id) return;

    btn.disabled = true;
    try {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: Number(id), quantity: 1 })
      });
      window.location.href = "/checkout";
    } catch (err) {
      console.error(err);
      btn.disabled = false;
      alert("Couldn’t add to cart. Please try again.");
    }
  });

  // -------------------------
  // View dropdown (List / Gallery)
  // -------------------------
  function initViewSwitch() {
    var root = document.querySelector("[data-view-switch]");
    if (!root) return;

    var trigger = root.querySelector("[data-view-trigger]");
    var menu = root.querySelector("[data-view-menu]");
    var items = root.querySelectorAll("[data-view]");
    var grid = document.querySelector(".product-grid");
    var iconMount = root.querySelector("[data-view-trigger-icon]");

    if (!trigger || !menu || !items.length || !grid || !iconMount) return;

    // SVGs for the trigger (current mode)
    var ICONS = {
      list:
        '<svg width="18" height="18" viewBox="0 0 20 20" aria-hidden="true">' +
        '<path d="M4 6h12M4 10h12M4 14h12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
        '<path d="M2 6h0M2 10h0M2 14h0" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>' +
        "</svg>",
      grid:
        '<svg width="18" height="18" viewBox="0 0 20 20" aria-hidden="true">' +
        '<rect x="3" y="3" width="6" height="6" rx="1.2" fill="none" stroke="currentColor" stroke-width="1.6"/>' +
        '<rect x="12" y="3" width="6" height="6" rx="1.2" fill="none" stroke="currentColor" stroke-width="1.6"/>' +
        '<rect x="3" y="12" width="6" height="6" rx="1.2" fill="none" stroke="currentColor" stroke-width="1.6"/>' +
        '<rect x="12" y="12" width="6" height="6" rx="1.2" fill="none" stroke="currentColor" stroke-width="1.6"/>' +
        '</svg>'
    };

    // set initial state from storage
    var saved = localStorage.getItem("collectionView");
    var view = (saved === "list" || saved === "grid") ? saved : "grid";

    function applyView(v) {
      if (v === "list") grid.classList.add("is-list");
      else grid.classList.remove("is-list");

      items.forEach(function (btn) {
        btn.classList.toggle("is-active", btn.getAttribute("data-view") === v);
      });

      // Set trigger icon to the current mode
      iconMount.innerHTML = ICONS[v] || ICONS.grid;

      // Update accessible label too
      trigger.setAttribute("aria-label", v === "list" ? "List view" : "Gallery view");

      localStorage.setItem("collectionView", v);
    }

    function openMenu() {
      menu.hidden = false;
      trigger.setAttribute("aria-expanded", "true");
    }

    function closeMenu() {
      menu.hidden = true;
      trigger.setAttribute("aria-expanded", "false");
    }

    // Apply initial
    applyView(view);

    // Toggle open/close
    trigger.addEventListener("click", function (e) {
      e.preventDefault();
      if (menu.hidden) openMenu();
      else closeMenu();
    });

    // Choose option
    items.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var v = btn.getAttribute("data-view");
        applyView(v);
        closeMenu();
      });
    });

    // Close when clicking outside
    document.addEventListener("click", function (e) {
      if (!root.contains(e.target)) closeMenu();
    });

    // Close on Escape
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeMenu();
    });
  }

  // -------------------------
  // Mobile Filters Drawer
  // -------------------------
  function initMobileFiltersDrawer() {
    var sidebar = document.querySelector(".collection-sidebar");
    var form = document.getElementById("CollectionFiltersForm");
    if (!sidebar || !form) return;

    // Ensure the sidebar has an id for aria-controls
    sidebar.id = sidebar.id || "MobileFilters";

    // Footer (once)
    if (!sidebar.querySelector(".mobile-filters__footer")) {
      var footer = document.createElement("div");
      footer.className = "mobile-filters__footer";
      footer.innerHTML =
        '<button type="button" class="mobile-filters__btn" data-filters-close>Close</button>' +
        '<button type="button" class="mobile-filters__btn mobile-filters__btn--apply" data-filters-apply>Apply</button>';

      sidebar.appendChild(footer);
    }

    function open() {
      document.body.classList.add("is-filters-open");
      var openBtn = document.querySelector("[data-filters-open]");
      if (openBtn) openBtn.setAttribute("aria-expanded", "true");
    }

    function close() {
      document.body.classList.remove("is-filters-open");
      var openBtn = document.querySelector("[data-filters-open]");
      if (openBtn) openBtn.setAttribute("aria-expanded", "false");
    }

    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-filters-open]")) {
        e.preventDefault();
        open();
        return;
      }

      if (e.target.closest("[data-filters-close]")) {
        e.preventDefault();
        close();
        return;
      }

      if (e.target.closest("[data-filters-apply]")) {
        e.preventDefault();
        // submit the existing form
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
        return;
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
    });
  }

  initMobileFiltersDrawer();

  // -------------------------
  // AJAX Sort
  // -------------------------
  function initAjaxSort() {
    var sortSelect = document.querySelector("#SortBy");
    if (!sortSelect) return;

    async function applySort(value) {
      var url = new URL(window.location.href);
      url.searchParams.set("sort_by", value);
      url.searchParams.delete("page");

      try {
        var res = await fetch(url.toString(), { credentials: "same-origin" });
        if (!res.ok) return;

        var html = await res.text();
        var doc = new DOMParser().parseFromString(html, "text/html");

        var newMain = doc.querySelector(".collection-main");
        var currentMain = document.querySelector(".collection-main");

        if (newMain && currentMain) {
          currentMain.innerHTML = newMain.innerHTML;
          window.history.pushState({}, "", url.toString());

          // Re-init features after DOM swap
          initAjaxSort();
          initViewSwitch();
          initPriceQuickButtons();
          watchRerenders();
          // autoSelectInStockOnFirstLoad()
          initMobileFiltersDrawer && initMobileFiltersDrawer();
        }
      } catch (err) {
        console.error("Sort AJAX failed:", err);
      }
    }

    // Select (fallback + keyboard users)
    sortSelect.addEventListener("change", function () {
      applySort(sortSelect.value);
    });

    // Icon menu
    var root = document.querySelector("[data-sort-switch]");
    if (!root) return;

    var trigger = root.querySelector("[data-sort-trigger]");
    var menu = root.querySelector("[data-sort-menu]");
    var items = root.querySelectorAll("[data-sort-value]");

    if (!trigger || !menu || !items.length) return;

    function setActive(value) {
      items.forEach(function (btn) {
        btn.classList.toggle("is-active", btn.getAttribute("data-sort-value") === value);
      });
    }

    function openMenu() {
      menu.hidden = false;
      trigger.setAttribute("aria-expanded", "true");
    }

    function closeMenu() {
      menu.hidden = true;
      trigger.setAttribute("aria-expanded", "false");
    }

    // initial active state from select
    setActive(sortSelect.value);

    trigger.addEventListener("click", function (e) {
      e.preventDefault();
      if (menu.hidden) openMenu();
      else closeMenu();
    });

    items.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var v = btn.getAttribute("data-sort-value");
        if (!v) return;

        // Update hidden select (keeps state consistent)
        sortSelect.value = v;
        setActive(v);
        closeMenu();

        applySort(v);
      });
    });

    // close outside click
    document.addEventListener("click", function (e) {
      if (!root.contains(e.target)) closeMenu();
    });

    // close on escape
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeMenu();
    });
  }

  // Run
  sanitizeCollectionUrl({ replaceHistory: true });
  initPriceQuickButtons();
  scheduleUniformMediaHeight();
  watchRerenders();
  initAjaxSort();
  // autoSelectInStockOnFirstLoad()
  initViewSwitch();
})();